<template lang="pug">
  .section-layout
    slide-out-modal(@input="toggleSidePannel" v-if="show_mode")
      choose-customer(:id="info.choose_limit" @success="seleckType")
    .nav-back-btn(@click="goBack")
    .content-wrapper
      h2 {{detail ? '查看活动' : '编辑活动'}}
      .activity-wrapper(:class="{'center': detail}")
        //- 预览区域
        .phone-wrapper
          .phone-contents
            .phone-header(:class="{'active-head': is_select_head}", @click="selectHead")
              .phone-top
                img(width="375", src="../../assets/template/mobile-header.png")
              .phone-head
                .phone-title {{info.title}}
                img(class="phone-icon", src="../../assets/template/mobile-button.png")
            //- .banner(:class="{'active-head': is_select_head}", @click="selectHead")
            //-   .title {{info.title}}

            .phone-content(v-if="info.relation.length")
              .phone-item-box(v-for="(item, index) in info.relation", :class="{'active-item': index === active_index, 'card-item': item.type === 5}")
                .phone-item(@click="changeItem(index, item)")
                  .editor-wrapper(v-if="item.type === 1")
                    .content-title
                      div {{info.activity_content.title}}
                    .content-text(v-html="info.activity_content.content")
                  .enroll-wrapper(v-if="item.type === 2")
                    img(width="100%", src="../../assets/template/mobile-car2.png")
                    .num(v-if="!info.selected_stores.length") 查看活动门店
                    .num(v-else) 查看 {{info.selected_stores.length}}家 活动门店
                  //- 展示区域
                  .goods-wrapper(v-if="(info.sign_up_switch === 1 || info.sign_up_switch) && item.type === 2")
                    img(width="100%", src="../../assets/template/people.png")
                  .goods-wrapper(v-if="item.type === 3 || item.type === 4")
                    goods(:goodsItem="item")
                  .card-wrapper(v-if="item.type === 5")
                    card(:cardItem="item")
                  .group-mange-wrapper(v-if="item.type === 6")
                    groupCategory(:groupCategoryItem="item")
                  .time-limit-wrapper(v-if="item.type === 7")
                    timeLimitGoods(:timeLimitGoodsItem="item")
                  .coupon-wrapper(v-if="item.type === 8")
                    coupon(:couponItem="item")
                  .help-wrapper(v-if="item.type === 9")
                    help(:helpItem="info.help_info")
                  .card-wrapper(v-if="item.type === 10")
                    img(width="100%", src="../../assets/template/user.png")

                //- 排序
                .phone-sort(v-if="!detail")
                  .up(:class="{'disabled': index === 0}",  @click="sortItem(item.id, index, 'up')")
                  .down(:class="{'disabled': index === info.relation.length - 1}",  @click="sortItem(item.id, index, 'down')")
                  .line
                  .delete(@click="deleteItem(index, item)")

            el-popover(placement="right", width="400", trigger="click", v-model="show_popover_visible", v-if="!detail")
              .add-box
                a.button.primary.large(v-for="(item, index) in button_list", :key="index", @click="addActivity(index, item.type, null, item.disabled)", :class="{'disabled': item.disabled}") {{item.text}}
              .phone-add(slot="reference")
                img(class="icon", slot="reference", src="../../assets/template/mobile-add.png")

        .line-wrapper

        //- 编辑区域
        .edit-wrapper
          //- .title 编辑
          .content.field-group(v-if="is_select_head")
            .field.is-horizontal
              label.label 名称
              custom-input(v-model="info.title", maxlength=15, placeholder="请输入活动名称", :validator="$v.info.title", error-info="名称不能为空", :is-disabled="detail == 1")
            .field.is-horizontal
              label.label 品牌
              custom-select(v-model="info.brand", :list="brand_list", nameField="brand_name", :show-search="true", :is-disabled="detail == 1")
            .field.is-horizontal
              label.label 封面图
              upload-pic(v-model="info.cover", img-type="info.cover", :img-id="1", :is-disabled="detail == 1")
              .tips-text 封面图建议上传尺寸750*340px, 大小不超过1M
            .field.is-horizontal
              label.label 活动简介
              textarea.textarea(v-model="info.description", maxlength=50, placeholder="活动简介会显示到企微端活动海报上", :disabled="!!detail")
            .field.is-horizontal
              label.label 活动时间
              .field.is-horizontal
                date-picker.width-40(type="single",placeholder="请选择开始时间", v-model="info.start_time",:validator="$v.info.start_time",  error-info="请选择活动开始时间", :is-disabled="active_status === 1 || detail == 1")
                span.m-l-20 至
                date-picker.width-40.m-l-20(type="single",placeholder="请选择结束时间", v-model="info.end_time",:validator="$v.info.end_time",  error-info="请选择活动结束时间", :is-disabled="detail == 1")
            .field.is-horizontal(v-if="!detail")
              label.label 人群限制
              .radio
                input(id="join01" type="radio" name="join" v-model="info.user_limit" :value="0")
                label(for="join01") 无限制
              .radio.m-l-20
                input(id="join02" type="radio" name="join" v-model="info.user_limit" :value="1")
                label(for="join02")
              a.button.m-l-20(@click="toggleSidePannel()", :class="info.user_limit == 1 ? 'primary' : 'not-allow'") 指定人群
              .txt.m-l-20(v-if="info.choose_limit && info.user_limit == 1", style="font-size: 13px")
                span(v-if="info.choose_limit == 1") 小程序已下单客户
                span(v-if="info.choose_limit == 2") 小程序未下单客户
            .field.is-horizontal(v-if="detail")
              label.label 人群限制
              .txt.m-l-20(v-if="info.choose_limit && info.user_limit == 1", style="font-size: 13px")
                span(v-if="info.choose_limit == 1") 小程序已下单客户
                span(v-if="info.choose_limit == 2") 小程序未下单客户
              span(v-else) 无限制
            .field.is-horizontal
              label.label 海报
              upload-pic(v-model="info.poster_img", img-type="info.poster_img", :img-id="2", :is-disabled="detail == 1")
              .tips-text 封面图建议上传尺寸750*340px, 大小不超过1M
          .content.field-group(v-if="active_type === 1")
            .field.is-horizontal
              label.label 内容标题
              custom-input(v-model="info.activity_content.title", maxlength=8, placeholder="请输入内容标题", :is-disabled="detail == 1")
            .field.is-horizontal
              label.label 活动内容
              .control
                rich-editor(:is-disabled="detail == 1", v-model="info.activity_content.content", ref="editor")
            .field.is-horizontal
              .label
              .tips-text.no-m 图片建议尺寸宽度为720px, 图片大小不超过5M
          .content.field-group.enroll(v-if="active_type === 2 && current_store.is_chain == 1")
            .title-store 活动门店
            .store_wrapper(v-for="(item, index) in stores_list", :key="index")
              .checkbox(style="cursor: default")
                input(type="checkbox", :id="item.store_id", :value="item.store_id" v-model="info.selected_stores" :disabled="!!detail")
                label(:for="item.store_id", style="cursor: default") {{item.store_name}}
            //- .title-store.margin-t-20  小程序报名用户
            //- .store_wrapper
            //-   .checkbox
            //-     input(type="checkbox", v-model="info.sign_up_switch", value="0",)
            //-     label 小程序页面报名成功用户展示
          .content.field-group.enroll(v-if="active_type === 2 && current_store.is_chain != 1")
            .title-store 活动门店
            .store_wrapper(v-for="(item, index) in store_list", :key="index")
              .checkbox(style="cursor: default", class="disabled")
                input(type="checkbox", :id="item.store_id", :value="item.store_id" v-model="info.selected_stores" :disabled="!!detail")
                label(:for="item.store_id", style="cursor: default") {{item.store_name}}
            //- .title-store.margin-t-20 小程序报名用户
            //- .store_wrapper
            //-   .checkbox
            //-     input(type="checkbox", v-model="info.sign_up_switch", value="0",)
            //-     label 小程序页面报名成功用户展示
          .content.field-group(v-if="active_type === 3 && !detail")
            .button-group
              a.button.primary.large(@click="addActivity(null, 3, active_index)") 选择商品
          .content.field-group(v-if="active_type === 4 && !detail")
            .button-group
              a.button.primary.large(@click="addActivity(null, 4, active_index)") 选择服务
          .content.field-group(v-if="active_type === 5 && !detail")
            .button-group
              a.button.primary.large(@click="addActivity(null, 5, active_index)") 选择养护卡
          .content.field-group(v-if="active_type === 6 && !detail")
            .button-group
              a.button.primary.large(@click="addActivity(null, 6, active_index)") 选择拼团
          .content.field-group(v-if="active_type === 7 && !detail")
            .button-group
              a.button.primary.large(@click="addActivity(null, 7, active_index)") 选择秒杀
          .content.field-group(v-if="active_type === 8 && !detail")
            .button-group
              a.button.primary.large(@click="addActivity(null, 8, active_index)") 选择优惠券
          .content.field-group(v-if="active_type === 9")
            .label-title
              span 基本信息配置
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 助力时长
                custom-input(
                  :is-disabled="detail == 1"
                  v-model="info.help_info.duration",
                  need-type="number"
                  input-type="hasUnit",
                  maxlength=3,
                  :validator="$v.help_info.duration"
                  error-info="助力时长不能为空且为大于0的整数"
                  placeholder="上限为999小时",)
                  span(slot="unitName") 小时
              .is-red 用户发起助力时间到助力截止时间
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 助力人数
                custom-input(
                  :is-disabled="detail == 1"
                  v-model="info.help_info.num",
                  need-type="number"
                  input-type="hasUnit",
                  maxlength=2,
                  :validator="$v.help_info.num"
                  error-info="助力人数不能为空且为大于0的整数"
                  max="10"
                  placeholder="上限为10人",)
                  span(slot="unitName") 人
              .is-red 助力活动的参与的人数，当达到参与人数，助力活动成功
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 活动助力总数
                custom-input(
                  :is-disabled="detail == 1 || active_edit "
                  v-model="info.help_info.help_total",
                  need-type="number"
                  input-type="hasUnit",
                  maxlength=3,
                  :validator="$v.help_info.help_total"
                  error-info="活动助力总数不能为空"
                  max="999"
                  placeholder="输入0代表无限制",)
                  span(slot="unitName") 次
              .is-red 本次助力活动，允许发起者成功助力的总数量
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 发起助力限制
                .field.is-horizontal
                  span(style="width: 80px; font-size: 12px; flex-shrink: 0") 每人可发起
                  custom-input(
                    :is-disabled="detail == 1"
                    v-model="info.help_info.launch_num",
                    :validator="$v.help_info.launch_num"
                    error-info="发起助力限制不能为空且为大于0的整数"
                    need-type="number"
                    input-type="hasUnit",
                    maxlength=2,
                    placeholder="上限为99次",)
                    span(slot="unitName") 次
              .is-red 每位发起助力活动的人，可发起的最大上限次数
            .field.is-horizontal
              .width-300.field.is-horizontal
                label.label 参与助力限制
                .radio
                  input(id="limit01" type="radio" name="limit" v-model="info.help_info.limit" :value="0" :disabled="!!detail")
                  label(for="limit01") 无限制
                .radio.m-l-20
                  input(id="limit02" type="radio" name="limit" v-model="info.help_info.limit" :value="1" :disabled="!!detail")
                  label(for="limit02") 新用户
            .field.is-horizontal(v-if="info.help_info.limit === 0")
              .width-300.field.is-horizontal
                label.label
                .field.is-horizontal
                  span(style="width: 80px; font-size: 12px; flex-shrink: 0") 每人可参与
                  custom-input(
                    :is-disabled="detail == 1"
                    v-model="info.help_info.assist_num",
                    need-type="number"
                    :validator="$v.help_info.assist_num"
                    error-info="参与助力限制不能为空且为大于0的整数"
                    input-type="hasUnit",
                    maxlength=2,
                    placeholder="上限为99次",)
                    span(slot="unitName") 次
              .is-red 每位参与助力活动的人，可参与的最大上限次数
            .field.is-horizontal
              label.label 助力规则
              .control-box
                textarea.textarea(v-model="info.help_info.rule", maxlength="500",placeholder="最多500个字")
            .label-title 奖励配置
            .field.is-horizontal
              label.label 发起者奖励
              input(type="radio" name="choose" v-model="info.help_info.type" :value="1" :disabled="!!detail")
              a.button.primary.m-l-20(v-if="!detail", @click="showCouponsHelp(1)") 选择优惠券
              span.m-l-20.tips(v-if="info.help_info.coupon_items.length > 0") 已选择{{info.help_info.coupon_items.length}}张
            .coupon-list(v-if="info.help_info.coupon_items.length > 0")
              el-row.thead
                el-col(:span="8") 名称
                el-col(:span="4")  类型
                el-col(:span="3")  金额/折扣
                el-col(:span="6")  使用范围
                el-col(v-if='!detail',:span="3")  操作
              el-row.tbody(v-for="(item, cindex) in info.help_info.coupon_items", :key="cindex")
                el-col(:span="8") {{item.coupon_name}}
                el-col(:span="4")
                  .simple-td(v-if="item.coupon_type === 1") 代金券
                  .simple-td(v-if="item.coupon_type === 2") 兑换券
                  .simple-td(v-if="item.coupon_type === 3") 满减券
                  .simple-td(v-if="item.coupon_type === 4") 折扣券
                el-col(:span="3") {{item.coupon_type === 4 ? (item.discount_amount / 100) + ' 折' : '¥ ' + (item.discount_amount / 100)}}
                el-col(:span="6")
                  div(v-if="item.coupon_use_type")
                    .simple-td(v-if="item.coupon_use_type === 1") 小程序商城通用
                    .simple-td(v-if="item.coupon_use_type === 2") 指定分类
                    .simple-td(v-if="item.coupon_use_type === 3") 指定商品/服务
                    .simple-td(v-if="item.coupon_use_type === 4") 指定养护卡
                    .simple-td(v-if="item.coupon_use_type === 5") 线下买单/开单
                  div(v-else) --
                el-col(v-if='!detail',:span="3")
                  span.del(@click="deleteCoupon(1,cindex)") 删除
            .field.is-horizontal
              label.label 助力者奖励
              input(type="radio" name="helperchoose" id="help-choose1" v-model="info.help_info.helper_type" :value="0" :disabled="detail")
              label.plain-txt(for="help-choose1") 无奖励
              input(type="radio" name="helperchoose"  id="help-choose2" v-model="info.help_info.helper_type" :value="1" :disabled="detail")
              label.plain-txt(for="help-choose2") 有奖励
              a.button.primary.m-l-20(v-if="info.help_info.helper_type===1 && !detail", @click="showCouponsHelp(2)") 选择优惠券
              span.m-l-20.tips(v-if="info.help_info.helper_type===1 && info.help_info.helper_coupons.length > 0 && !detail") 已选择{{info.help_info.helper_coupons.length}}张
            .coupon-list(v-if="info.help_info.helper_type===1 && info.help_info.helper_coupons.length > 0 && !detail")
              el-row.thead
                el-col(:span="8") 名称
                el-col(:span="4")  类型
                el-col(:span="3")  金额/折扣
                el-col(:span="6")  使用范围
                el-col(:span="3")  操作
              el-row.tbody(v-for="(item, cindex) in info.help_info.helper_coupons", :key="cindex")
                el-col(:span="8") {{item.coupon_name}}
                el-col(:span="4")
                  .simple-td(v-if="item.coupon_type === 1") 代金券
                  .simple-td(v-if="item.coupon_type === 2") 兑换券
                  .simple-td(v-if="item.coupon_type === 3") 满减券
                  .simple-td(v-if="item.coupon_type === 4") 折扣券
                el-col(:span="3") {{item.coupon_type === 4 ? (item.discount_amount / 100) + ' 折' : '¥ ' + (item.discount_amount / 100)}}
                el-col(:span="6")
                  div(v-if="item.coupon_use_type && !detail")
                    .simple-td(v-if="item.coupon_use_type === 1") 小程序商城通用
                    .simple-td(v-if="item.coupon_use_type === 2") 指定分类
                    .simple-td(v-if="item.coupon_use_type === 3") 指定商品/服务
                    .simple-td(v-if="item.coupon_use_type === 4") 指定养护卡
                    .simple-td(v-if="item.coupon_use_type === 5") 线下买单/开单
                  div(v-else) --
                el-col(:span="3")
                  span.del(v-if="!detail", @click="deleteCoupon(2,cindex)") 删除
      .btn-wrapper
        .button-group(:class="{'center': detail}")
          a.button.primary.large(@click="saveData", v-if="active_status !== 2 && !detail") 保存
          a.button.large(@click="goBack", v-if="!detail") 取消
          a.button.large(@click="goBack", v-if="detail") 返回
      coupons-help(v-if="show_coupons_help", v-model="show_coupons_help", @resolve="getHelpCoupons", :type="coupon_open_type", :array="temp_coupon_arr", :end-time="info.end_time")
      choose-goods(v-if='show_choose_goods', v-model="show_choose_goods", @resolve="getContent", :array='info.goods_data', :editIndex="edit_index")
      choose-service(v-if='show_choose_service', v-model="show_choose_service", @resolve="getContent", :array='info.service_data', :editIndex="edit_index")
      choose-maintenance(v-if='show_choose_maintenance',v-model="show_choose_maintenance", @resolve="getContent", :array='info.upkeep_card_data', :editIndex="edit_index")
      choose-group-mange(v-if='show_choose_group_mange',v-model="show_choose_group_mange", @resolve="getContent", :array='info.group_mange_data', :editIndex="edit_index")
      choose-time-limit(v-if='show_choose_time_limit',v-model="show_choose_time_limit", @resolve="getContent", :array='info.time_limit_data', :editIndex="edit_index")
      choose-coupon(v-if='show_choose_coupon',v-model="show_choose_coupon", @resolve="getContent", :array='info.coupon_data', :editIndex="edit_index")

</template>

<script>
import Api from '@/mixins/modules/Content'
import upLoadApi from '@/mixins/utilities/fileUploader'
import CustomInput from '@/components/generics/form/CustomInput'
import CustomSelect from '@/components/generics/form/CustomSelect'
import UploadPic from '@/components/generics/form/UploadPic'
import RichEditor from '@/components/generics/form/RichEditor'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Utils from '@/mixins/utilities/utils'
import ChooseGoods from '@/components/content/modal/ChooseGoods'
import ChooseService from '@/components/content/modal/ChooseService'
import ChooseMaintenance from '@/components/content/modal/ChooseMaintenance'
import ChooseGroupMange from '@/components/content/modal/ChooseGroupManage'
import ChooseTimeLimit from '@/components/content/modal/ChooseTimeLimit'
import ChooseCoupon from '@/components/content/modal/ChooseCoupon'
import Coupon from '@/components/content/modal/Coupon'
import Goods from '@/components/content/modal/Goods'
import Card from '@/components/content/modal/Card'
import GroupCategory from '@/components/content/modal/GroupCategory'
import TimeLimitGoods from '@/components/content/modal/TimeLimitGoods'
import { mapGetters } from 'vuex'
import Help from '@/components/content/modal/Help'
import DatePicker from '@/components/generics/form/DatePicker'
import SlideOutModal from '@/components/generics/SlideOutModal'
import ChooseCustomer from '@/components/content/modal/ChooseCustomer'
import CouponsHelp from '@/components/content/modal/CouponsHelp'
import FormateDate from '@/mixins/utilities/formateDate'

export default {
  name: 'ContentEdit',
  mixins: [validationMixin, Api, upLoadApi, Utils, FormateDate],
  components: {
    CustomInput,
    CustomSelect,
    UploadPic,
    RichEditor,
    ChooseGoods,
    ChooseService,
    ChooseMaintenance,
    ChooseGroupMange,
    ChooseTimeLimit,
    ChooseCoupon,
    Coupon,
    Goods,
    Card,
    GroupCategory,
    TimeLimitGoods,
    SlideOutModal,
    ChooseCustomer,
    CouponsHelp,
    Help,
    DatePicker,
  },
  computed: {
    ...mapGetters({
      stores_list: 'stores',
      current_store: 'currentStore',
    }),
  },
  data () {
    return {
      // 1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券
      is_select_head: true, // 默认选中head
      active_type: null, // 当前选中的组件类型(右边编辑展示用)
      active_index: null, // 选中的组件下标(黄色选择框使用)
      edit_index: null, // 要编辑的组件的下标
      show_popover_visible: false, // 是否显示添加模态框
      show_choose_goods: false, // 是否显示选择商品模态框
      show_choose_service: false, // 是否显示选择服务模态框
      show_choose_maintenance: false, // 是否显示选择养护卡模态框
      show_choose_group_mange: false, // 是否显示选择拼团模态框
      show_choose_time_limit: false, // 是否显示选择秒杀模态框
      show_choose_coupon: false, // 是否显示选择优惠券模态框
      show_mode: false, // 是否展示选择指定用户弹框
      show_coupons_help: false, // 是否展示助力下选择优惠券弹框
      active_status: 0, // 活动状态 1 活动开始 2 活动结束
      info: {
        title: '', // 标题
        brand: {}, // 选择的品牌
        cover: '', // 封面图
        poster_img: '', // 海报背景图
        description: '', // 活动简介
        time: '',
        start_time: '', // 开始时间
        end_time: '', // 结束时间
        user_limit: 0, // 用户限制 0 指定用户 1
        choose_limit: '', // 未下单 2 已下单 1
        sign_up_switch: 0,
        help_info: {
          duration: '', // 助力时长
          num: '', // 助力人数
          rule: '', // 助力规则
          limit: 0, // 参与助力限制 0 无限制, 1 新用户
          launch_num: 1, // 发起次数
          assist_num: 1, // 参与次数
          type: 1,
          coupon_ids: [], // 优惠券id
          coupon_items: [], // 优惠券
          helper_type: 0, // 助力者是否开启奖励. 1开启， 0不开启
          helper_coupons: [], // 助力者奖励券
          helper_coupon_ids: [], // 助力者奖励券的id集合
          help_total: '',
        },
        goods_data: [], // 商品列表
        service_data: [], // 服务列表
        upkeep_card_data: [], // 养护卡列表
        group_mange_data: [], // 拼团列表
        time_limit_data: [], // 秒杀列表
        coupon_data: [], // 优惠券列表
        content: [], // 活动关联项目内容

        activity_content: { // 活动内容数据
          title: '',
          content: '',
        },
        selected_stores: [], // 选择的门店
        relation: [], // 活动组件
      },
      active_edit: false, // 活动是否可以被编辑
      button_list: [
        {
          text: '添加活动内容',
          type: 1,
        },
        {
          text: '添加报名信息',
          type: 2,
        },
        {
          text: '添加商品',
          type: 3,
        },
        {
          text: '添加服务',
          type: 4,
        },
        {
          text: '添加养护卡',
          type: 5,
        },
        {
          text: '添加拼团',
          type: 6,
        },
        {
          text: '添加秒杀',
          type: 7,
        },
        {
          text: '添加优惠券',
          type: 8,
        },
        {
          text: '添加助力活动',
          type: 9,
        },
        {
          text: '添加用户组件',
          type: 10,
        },
      ],
      brand_list: [], // 品牌列表
      temp_coupon_arr: [], // 优惠券配置弹窗的临时数组
      coupon_open_type: 1, // 区分是发起者的优惠券配置还是助力者的优惠券配置，1发起者，2助力者
      detail: false, // 是否为查看详情
    }
  },
  validations: {
    info: {
      title: {
        required,
      },
      start_time: {
        required,
      },
      end_time: {
        required,
      },
    },
    help_info: {
      duration: {
        validate () {
          if (this.checkHelp() !== -1 && !(this.info.help_info.duration - 0)) {
            return false
          }
          return true
        },
      },
      num: {
        validate () {
          if (this.checkHelp() !== -1 && !(this.info.help_info.num - 0)) {
            return false
          }
          return true
        },
      },
      help_total: {
        validate () {
          if (this.checkHelp() !== -1 && this.info.help_info.help_total === '') {
            return false
          }
          return true
        },
      },
      launch_num: {
        validate () {
          if (this.checkHelp() !== -1 && !(this.info.help_info.launch_num - 0)) {
            return false
          }
          return true
        },
      },
      assist_num: {
        validate () {
          if (this.checkHelp() !== -1 && !(this.info.help_info.assist_num - 0) && this.info.help_info.limit === 0) {
            return false
          }
          return true
        },
      },
    },
  },
  methods: {
    /**
     *  去掉左右空格
     * val String
     */
    checkTrim (val) {
      return val.replace(/(^\s*)|(\s*$)/g, '')
    },
    /**
     * 助力优惠券选择的回调
     * items 选择的优惠券数组
     */
    getHelpCoupons (items, type) {
      if (type === 1) {
        this.info.help_info.coupon_items = items
        this.info.help_info.coupon_ids = items.map(item => {
          return item.coupon_id
        })
      } else if (type === 2) {
        this.info.help_info.helper_coupons = items
        this.info.help_info.helper_coupon_ids = items.map(item => {
          return item.coupon_id
        })
      }
    },
    /**
     * @description  删除助力活动的优惠券
     * @param type {Number} 区分删除的是助力者还是发起者，1发起者，2助力者
     * @index {index} 删除的下标
     */
    deleteCoupon (type, index) {
      let str1 = type === 1 ? 'coupon_items' : 'helper_coupons'
      let str2 = type === 1 ? 'coupon_ids' : 'helper_coupon_ids'
      this.info.help_info[str1].splice(index, 1)
      this.info.help_info[str2].splice(index, 1)
    },
    /**
     * @description 是否展示助力下选择优惠券的弹框
     * @params type {Number} 区分是发起者还是助力者，1发起者，2助力者
     */
    showCouponsHelp (type) {
      this.coupon_open_type = type
      if (type === 1) {
        this.temp_coupon_arr = this.info.help_info.coupon_items
      } else {
        this.temp_coupon_arr = this.info.help_info.helper_coupons
      }
      if (type === 2 && this.info.help_info.helper_type === 0) {
        return
      }
      this.show_coupons_help = !this.show_coupons_help
    },
    // 展示助力组件；用户报错信息填写不全
    showHelp () {
      this.is_select_head = false
      this.active_index = this.checkHelp()
      this.active_type = 9
    },
    // 检查是否有助力活动
    checkHelp () {
      return this.info.relation.findIndex(item => {
        return item.type === 9
      })
    },
    toggleSidePannel () {
      if (this.info.user_limit === 1) {
        this.show_mode = !this.show_mode
      }
    },
    /**
     * 模态框回调的数据 指定用户
     * id {Number} 指定用户id 1 下单 2 未下单
     */
    async seleckType (id) {
      this.toggleSidePannel()
      this.info.choose_limit = id
    },
    /**
     * 添加活动内容
     * @type 组件类型
     * @index 序列号
     * @editIndex 要编辑的序号
     * @disabled 控制按钮是否可点击
     */
    // 1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券
    addActivity (index, type, editIndex, disabled) {
      if (disabled) {
        return
      }
      this.is_select_head = false
      this.show_popover_visible = false
      switch (type) {
        case 1:
          this.info.relation.push({
            type: 1,
          })
          this.info.relation.forEach((item, i) => {
            if (item.type === 1) {
              this.active_index = i
              this.active_type = 1
            }
          })
          this.button_list[0].disabled = true
          break
        case 2:
          this.info.relation.push({
            type: 2,
          })
          this.info.relation.forEach((item, i) => {
            if (item.type === 2) {
              this.active_index = i
              this.active_type = 2
            }
          })
          this.button_list[1].disabled = true
          break
        case 3:
          this.edit_index = editIndex
          this.show_choose_goods = true
          break
        case 4:
          this.edit_index = editIndex
          this.show_choose_service = true
          break
        case 5:
          this.edit_index = editIndex
          this.show_choose_maintenance = true
          break
        case 6:
          this.edit_index = editIndex
          this.show_choose_group_mange = true
          break
        case 7:
          this.edit_index = editIndex
          this.show_choose_time_limit = true
          break
        case 8:
          this.edit_index = editIndex
          this.show_choose_coupon = true
          break
        case 9:
          this.info.relation.push({
            type: 9,
          })
          this.info.relation.forEach((item, i) => {
            if (item.type === 9) {
              this.active_index = i
              this.active_type = 9
            }
          })
          this.button_list[8].disabled = true
          break
        case 10:
          this.info.relation.push({
            type: 10,
          })
          this.info.relation.forEach((item, i) => {
            if (item.type === 10) {
              this.active_index = i
              this.active_type = 10
            }
          })
          this.button_list[9].disabled = true
          break
        default:
          break
      }
    },
    /**
     * 选择组件
     * @params 选择的组件
     */
    getContent (params) {
      switch (params.type) {
        case 3:
          this.getContentFun('goods_data', params)
          break
        case 4:
          this.getContentFun('service_data', params)
          break
        case 5:
          this.getContentFun('upkeep_card_data', params)
          break
        case 6:
          this.getContentFun('group_mange_data', params)
          break
        case 7:
          this.getContentFun('time_limit_data', params)
          break
        case 8:
          this.getContentFun('coupon_data', params)
          break
        default:
          break
      }
    },
    /**
     * 选择组件函数
     * @arrKey 要添加数据数组对象
     * @param 要添加的参数
     */
    // 1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券
    getContentFun (arrKey, params) {
      // 如果有edit_index说明是编辑
      if (typeof this.edit_index === 'number') {
        if (typeof params.data.length !== 'number') {
          this.info.relation.splice(this.edit_index, 1, params.data)
        } else {
          // this.info.relation.splice(this.edit_index, 1)
        }
      } else {
        let curType = params.type
        let curKey = ''
        switch (curType) {
          case 3:
            curKey = 'shop_product_id'
            break
          case 4:
            curKey = 'product_id'
            break
          case 5:
            curKey = 'id'
            break
          case 6:
            curKey = 'product_id'
            break
          case 7:
            curKey = 'id'
            break
          case 8:
            curKey = 'coupon_id'
            break
          default:
            break
        }
        // 两边都有就忽略（等于没变），param.data里有，info.relation里没有，则加上
        params.data.forEach(i => {
          let hasSame = false
          this.info.relation.forEach(j => {
            if (j.type === curType && j[curKey] === i[curKey]) {
              hasSame = true
            }
          })
          if (!hasSame && typeof i.length !== 'number') {
            this.info.relation.push(i)
          }
        })
        // info.relation里有，params.data里没有，则减掉
        this.info.relation = this.info.relation.filter(i => {
          if (i.type !== curType) {
            return true
          }
          let hasSame = false
          params.data.forEach(j => {
            if (j.type === curType && j[curKey] === i[curKey]) {
              hasSame = true
            }
          })
          return hasSame
        })
      }
      let index = null
      this.info[arrKey] = []
      this.info.relation.forEach((item, i) => {
        if (item.type === params.type) {
          this.info[arrKey].push(item)
          index = i
          this.active_type = item.type
        }
      })
      switch (params.type) {
        case 3:
          this.button_list[2].disabled = this.info[arrKey].length >= 10
          break
        case 4:
          this.button_list[3].disabled = this.info[arrKey].length >= 10
          break
        case 5:
          this.button_list[4].disabled = this.info[arrKey].length >= 3
          break
        case 6:
          this.button_list[5].disabled = this.info[arrKey].length >= 2
          break
        case 7:
          this.button_list[6].disabled = this.info[arrKey].length >= 2
          break
        case 8:
          this.button_list[7].disabled = this.info[arrKey].length >= 6
          break
        default:
          break
      }
      // console.log('this.info[arrKey]', this.info[arrKey])
      this.active_index = index
    },
    /**
    * 删除
    * @index {int} 序列号
    * @item 要删除的组件
    */
    // 1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券
    deleteItem (index, item) {
      this.$store.dispatch('showMessage', {
        title: '删除提示？',
        content: '确定删除当前组件吗？',
        isRejectable: 1,
        resolve: () => {
          switch (item.type) {
            case 1:
              this.info.relation.splice(index, 1)
              this.info.content = ''
              let index1 = this.button_list.findIndex(item => {
                return item.type === 1
              })
              this.button_list[index1].disabled = false
              this.info.activity_content = { // 活动内容数据
                title: '',
                content: '',
              }
              this.selectHead()
              break
            case 2:
              this.info.relation.splice(index, 1)
              this.info.selected_stores = []
              let index2 = this.button_list.findIndex(item => {
                return item.type === 2
              })
              this.button_list[index2].disabled = false
              this.selectHead()
              break
            case 3:
              this.deleteItemFun('goods_data', index, item, 'shop_product_id')
              break
            case 4:
              this.deleteItemFun('service_data', index, item, 'product_id')
              break
            case 5:
              this.deleteItemFun('upkeep_card_data', index, item, 'id')
              break
            case 6:
              this.deleteItemFun('group_mange_data', index, item, 'id')
              break
            case 7:
              this.deleteItemFun('time_limit_data', index, item, 'id')
              break
            case 8:
              this.deleteItemFun('coupon_data', index, item, 'id')
              break
            case 9:
              this.info.relation.splice(index, 1)
              let index9 = this.button_list.findIndex(item => {
                return item.type === 9
              })
              this.info.help_info = {
                duration: '', // 助力时长
                num: '', // 助力人数
                rule: '', // 助力规则
                limit: 0, // 参与助力限制 0 无限制, 1 新用户
                launch_num: 1, // 发起次数
                assist_num: 1, // 参与次数
                type: 1,
                coupon_ids: [], // 优惠券id
                coupon_items: [], // 优惠券
                helper_type: 0, // 助力者是否开启奖励. 1开启， 0不开启
                helper_coupons: [], // 助力者奖励券
                helper_coupon_ids: [], // 助力者奖励券的id集合
                help_total: '',
              }
              this.button_list[index9].disabled = false
              this.selectHead()
              break
            case 10:
              this.info.relation.splice(index, 1)
              let index10 = this.button_list.findIndex(item => {
                return item.type === 10
              })
              this.button_list[index10].disabled = false
              this.selectHead()
              break
            default:
              break
          }
        },
      })
    },
    /**
     * 删除组件
     * @arrKey 要删除数据数组对象
     * @index 序列号
     * @item 要删除的对象
     * @itemKey 要删除的对象的key
     */
    // 1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券
    deleteItemFun (arrKey, index, item, itemKey) {
      this.info[arrKey].forEach((x, i) => {
        if (x[itemKey] === item[itemKey]) {
          this.info[arrKey].splice(i, 1)
        }
      })
      this.info.relation.splice(index, 1)
      // console.log(arrKey)
      switch (arrKey) {
        case 'goods_data':
          if (this.info[arrKey].length < 10) {
            this.button_list[2].disabled = false
          }
          break
        case 'service_data':
          if (this.info[arrKey].length < 10) {
            this.button_list[3].disabled = false
          }
          break
        case 'upkeep_card_data':
          if (this.info[arrKey].length < 3) {
            this.button_list[4].disabled = false
          }
          break
        case 'group_mange_data':
          if (this.info[arrKey].length < 2) {
            this.button_list[5].disabled = false
          }
          break
        case 'time_limit_data':
          if (this.info[arrKey].length < 2) {
            this.button_list[6].disabled = false
          }
          break
        default:
          break
      }
      this.selectHead()
    },
    /**
    * 切换组件
    * @index 序列号
    * @item 选中的组件
    */
    changeItem (index, item) {
      this.is_select_head = false
      this.active_index = index
      this.active_type = item.type
    },
    // 选择头部
    selectHead () {
      this.is_select_head = true
      this.active_index = null
      this.active_type = null
    },
    /**
     * 排序
     * @id id
     * @index {int} 序列号
     * @type {string} up or down
     */
    sortItem (id, index, type) {
      if (index === 0 && type === 'up' ||
        index === this.info.relation.length - 1 && type === 'down') {
        return
      }
      let arr = [...this.info.relation]
      this.info.relation = []
      let temp = arr[index]
      // 向上移动
      if (type === 'up') {
        arr[index] = arr[index - 1]
        arr[index - 1] = temp
      }
      // 向下移动
      if (type === 'down') {
        arr[index] = arr[index + 1]
        arr[index + 1] = temp
      }
      this.info.relation = [...arr]
    },
    // 返回列表页
    goBack () {
      this.$router.push({
        name: 'contentList',
        query: {
          save: 1,
        },
      })
    },
    // 验证数据
    validateData () {
      let _this = this
      let pass = true
      // 是否添加了活动内容组件
      let contentFlag = this.info.relation.some(item => {
        return item.type === 1
      })
      // 是否添加了报名组件
      let enrollFlag = this.info.relation.some(item => {
        return item.type === 2
      })
      // 是否添加了用户活动组件
      let userFlag = this.info.relation.some(item => {
        return item.type === 10
      })
      if (!_this.info.brand.brand_id) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: ' 品牌不能为空',
        })
        this.selectHead()
        pass = false
        return pass
      }
      if (!_this.info.cover) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '封面图不能为空',
        })
        this.selectHead()
        pass = false
        return pass
      }
      if (!_this.info.poster_img) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '海报不能为空',
        })
        this.selectHead()
        pass = false
        return pass
      }
      let start = new Date(_this.info.start_time.replace(/-/g, '/') + ' 00:00')
      let end = new Date(_this.info.end_time.replace(/-/g, '/') + ' 23:59:59')
      if (end < start) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '活动结束时间需大于开始时间',
        })
        this.selectHead()
        pass = false
        return pass
      }
      if (end < +new Date()) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '活动结束时间需大于当前时间',
        })
        this.selectHead()
        pass = false
        return pass
      }
      if (_this.info.user_limit === 1 && !_this.info.choose_limit) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请选择指定人群',
        })
        this.selectHead()
        pass = false
        return pass
      }
      if (!_this.info.description) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '内容描述不能为空',
        })
        this.selectHead()
        pass = false
        return pass
      }
      if (!contentFlag && _this.checkHelp() === -1) {
        // this.scroll(1)
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '必须有活动内容或者助力活动',
        })
        pass = false
        return pass
      }
      if (userFlag) {
        let arr = this.info.relation.filter(item => { return item.type !== 10 && item.type !== 1 })
        if (arr.length <= 0) {
          _this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '用户组件需与除活动内容外的其他组件组合添加！',
          })
          pass = false
          return pass
        }
        console.log(arr)
      }
      if (contentFlag && (!_this.info.activity_content.title || !_this.info.activity_content.content)) {
        // this.scroll(1)
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '内容标题及活动内容不能为空',
        })
        pass = false
        return pass
      }
      if (enrollFlag && !_this.info.selected_stores.length) {
        this.scroll(2)
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请选择参与活动门店',
        })
        pass = false
        return pass
      }
      // 是否添加了助力和填写了活动规则
      if (_this.checkHelp() !== -1 && !_this.checkTrim(_this.info.help_info.rule)) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请填写助力活动规则',
        })
        _this.showHelp()
        pass = false
        return pass
      }
      // 是否添加了助力选择了优惠券
      if (_this.checkHelp() !== -1 && _this.info.help_info.coupon_ids.length === 0) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请选择助力活动发起者奖励优惠券',
        })
        _this.showHelp()
        pass = false
        return pass
      }
      // 是否添加了助力选择了助力者奖励优惠券
      if (_this.checkHelp() !== -1 && _this.info.help_info.helper_type === 1 && _this.info.help_info.helper_coupon_ids.length === 0) {
        _this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请选择助力活动助力者奖励优惠券',
        })
        _this.showHelp()
        pass = false
        return pass
      }
      return pass
    },
    /**
     * 滚动页面到对应位置
     * @type 组件类型
     */
    scroll (type) {
      let index = null
      this.info.relation.forEach((item, i) => {
        if (item.type === type) {
          index = i
          this.active_type = item.type
        }
      })
      this.is_select_head = null
      this.active_index = index
    },
    // 格式化数据
    formateData () {
      // 1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券
      let params = {
        activity_id: this.info.activity_id,
        title: this.info.title, // 标题
        brand_id: this.info.brand.brand_id, // 选择的品牌id
        brand_name: this.info.brand.brand_name, // 选择的品牌name
        cover: this.info.cover, // 封面图
        poster_img: this.info.poster_img, // 海报背景图
        description: this.info.description, // 活动简介
        end_time: (new Date(this.info.end_time.replace(/-/g, '/') + ' 23:59:59')) / 1000, // 结束时间
        user_limit: this.info.user_limit ? this.info.choose_limit : 0,
        relation: [], // 活动组件
        sign_up_switch: this.info.sign_up_switch ? 1 : 0,
      }
      // 当活动进行时不传开始时间
      if (this.active_status !== 1) {
        params.start_time = (new Date(this.info.start_time.replace(/-/g, '/') + ' 00:00')) / 1000 // 开始时间
      }
      this.info.relation.forEach(item => {
        switch (item.type) {
          case 1:
            params.relation.push(
              {
                type: 1,
                content: {
                  title: this.info.activity_content.title,
                  content: this.info.activity_content.content,
                },
              },
            )
            break
          case 2:
            params.relation.push(
              {
                type: 2,
                content: {
                  store_ids: this.info.selected_stores,
                },
              },
            )
            break
          case 3:
            params.relation.push({
              type: 3,
              item_id: item.shop_product_id,
              item_extra_id: item.item_extra_id || item.product_id,
            })
            break
          case 4:
            params.relation.push({
              type: 4,
              item_id: item.product_id,
              item_extra_id: item.item_extra_id || item.basic_spu_id,
            })
            break
          case 5:
            params.relation.push({
              type: 5,
              item_id: item.id,
            })
            break
          case 6:
            params.relation.push({
              type: 6,
              item_id: item.id,
            })
            break
          case 7:
            params.relation.push({
              type: 7,
              item_id: item.id,
            })
            break
          case 8:
            params.relation.push({
              type: 8,
              item_id: item.coupon_id,
            })
            break
          case 9:
            let data = this.info.help_info
            params.relation.push({
              type: 9,
              content: {
                duration: data.duration, // 助力时长
                num: data.num, // 助力人数
                rule: data.rule, // 助力规则
                limit: data.limit, // 参与助力限制 0 无限制, 1 新用户
                launch_num: data.launch_num, // 发起次数
                assist_num: data.limit === 0 ? data.assist_num : 0, // 参与次数
                coupon_ids: data.coupon_ids, // 优惠券id
                assist_prize: data.helper_type,
                assist_coupon_ids: data.helper_type === 1 ? data.helper_coupon_ids : [],
                help_total: data.help_total,
              },
            })
            break
          case 10:
            params.relation.push(
              {
                type: 10,
              },
            )
            break
          default:
            break
        }
      })
      return params
    },
    // 保存数据
    async saveData () {
      this.$v.info.$touch()
      if (this.$v.info.$error) {
        this.selectHead()
        return false
      }
      // 活动助力校验
      if (this.checkHelp() !== -1) {
        this.$v.help_info.$touch()
        if (this.$v.help_info.$error) {
          this.showHelp()
          return false
        }
      }

      // 验证数据
      let res = this.validateData()
      if (!res) {
        return false
      }
      let params = this.formateData()
      console.log(params)
      try {
        const { response, result } = await this.SetActivityEditApi(params)
        if (response.status === 200) {
          if (result.code === 0) {
            this.$store.dispatch('showMessage', {
              autoClose: true, // 控制弹框自动消失
              type: 'success',
              title: '保存活动成功',
              resolve: () => {
                this.$router.push({
                  name: 'contentList',
                })
              },
            })
          } else {
            this.$store.dispatch('showMessage', {
              type: 'failure',
              title: '保存活动出错',
              content: `${result.message}`,
            })
          }
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '保存活动出错',
            content: `出错啦！错误码：${response.status}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '保存活动出错',
          content: `出错啦！错误码：${err}`,
        })
      }
    },
    // 获取品牌列表
    async getBrandList () {
      try {
        const { response, result } = await this.BrandListApi({
          page: '1',
          per_page: '9999',
          is_page: 1,
        })
        if (response.status === 200) {
          this.brand_list = result.data
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取品牌列表出错',
            content: `出错啦！错误码：${response.status}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取品牌列表失败',
          content: `出错啦！错误码：${err}`,
        })
      }
    },
    // 获取活动详情
    async activityDetail () {
      try {
        const { response, result } = await this.GetActivityDetailApi({
          activity_id: this.activity_id,
        })
        if (response.status === 200) {
          this.info.activity_id = result.data.activity_id
          this.info.title = result.data.title
          this.info.brand = {
            brand_id: result.data.brand_id,
            brand_name: result.data.brand_name,
          }
          this.info.sign_up_switch = 0
          // this.info.sign_up_switch = result.data.sign_up_switch
          if (result.data.user_limit) {
            this.info.user_limit = result.data.user_limit - 0 ? 1 : 0
            this.info.choose_limit = result.data.user_limit - 0 || ''
          }
          if (result.data.start_time) {
            // 判断活动是否结束
            if (result.data.end_time * 1000 < +new Date()) {
              this.active_status = 2
            }
            // 活动是否进行
            if ((result.data.end_time * 1000 > +new Date()) && (result.data.start_time * 1000 < +new Date())) {
              this.active_status = 1
            }
            this.info.start_time = this.formateDate(result.data.start_time, false, 2)
            this.info.end_time = this.formateDate(result.data.end_time, false, 2)
          }
          this.info.cover = result.data.cover
          this.info.poster_img = result.data.poster_img
          this.info.description = result.data.description
          // 1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券
          let relation = []
          result.data.relation.forEach(item => {
            switch (item.type) {
              case 1:
                relation.push({
                  type: 1,
                })
                this.info.activity_content.title = item.object_extra.title
                this.info.activity_content.content = item.object_extra.content.replace(/<img/g, '<img style="max-width:100%;height:auto" ')
                this.button_list[0].disabled = true
                break
              case 2:
                relation.push({
                  type: 2,
                })
                this.info.selected_stores = item.object_extra.store_ids
                this.button_list[1].disabled = true
                break
              case 3:
                relation.push({
                  type: 3,
                  shop_product_id: item.item_id,
                  name: item.item_name,
                  pic: item.item_pic,
                  mini_price: item.sell_price,
                  item_extra_id: item.item_extra_id,
                })
                break
              case 4:
                relation.push({
                  type: 4,
                  product_id: item.item_id,
                  pic: item.item_pic,
                  name: item.item_name,
                  mini_price: item.sell_price,
                  item_extra_id: item.item_extra_id,
                })
                break
              case 5:
                relation.push({
                  type: 5,
                  id: item.item_id,
                  image_url: item.item_pic,
                  name: item.item_name,
                  num: item.num,
                  price: item.sell_price,
                  origin_price: item.origin_price,
                })
                break
              case 6:
                relation.push({
                  type: 6,
                  id: item.item_id,
                  num: item.num,
                  product_name: item.item_name,
                  goods_price: item.group_price,
                  pic: item.item_pic,
                  mini_price: item.group_price,
                  origin_price: item.sell_price,
                })
                break
              case 7:
                relation.push({
                  type: 7,
                  id: item.item_id,
                  product: {
                    name: item.item_name,
                    seckill_sku_price: item.sell_price,
                    sku_price: item.sell_price,
                    inventory_total: item.inventory_total,
                    pic: item.item_pic,
                    mini_price: item.limit_price,
                    origin_price: item.sell_price,
                  },
                })
                break
              case 8:
                relation.push({
                  type: 8,
                  coupon_id: item.item_id,
                  coupon_type: item.coupon_type,
                  discount_amount: item.discount_amount,
                  coupon_name: item.item_name,
                  effective_days: item.effective_days,
                  coupon_use_type_name: item.coupon_use_type_name,
                  condition_value: item.condition_value,
                })
                break
              case 9:
                relation.push({
                  type: 9,
                  id: item.id,
                })
                let content = item.content
                this.info.help_info = {
                  duration: content.duration,
                  num: content.num,
                  rule: content.rule, // 助力规则
                  limit: content.assist_num ? 0 : 1, // 参与助力限制 0 无限制, 1 新用户
                  launch_num: content.launch_num, // 发起次数
                  type: 1,
                  assist_num: content.assist_num || 1, // 参与次数
                  coupon_items: content.coupon, // 优惠券id,
                  helper_coupons: content.assist_coupon, // 助力者优惠券
                  helper_type: content.assist_prize, // 是否开启助力者奖励
                  helper_coupon_ids: content.assist_coupon.map(a => a.coupon_id),
                  help_total: content.help_total,
                }
                this.info.help_info.coupon_ids = content.coupon.map(cell => {
                  return cell.coupon_id
                })
                this.button_list[8].disabled = true
                break
              case 10:
                relation.push(
                  {
                    type: 10,
                  },
                )
                this.button_list[9].disabled = true
                break
              default:
                break
            }
          })


          this.info.relation = relation
          this.info.relation.forEach(item => {
            switch (item.type) {
              case 3:
                this.info.goods_data.push(item)
                break
              case 4:
                this.info.service_data.push(item)
                break
              case 5:
                this.info.upkeep_card_data.push(item)
                break
              case 6:
                this.info.group_mange_data.push(item)
                break
              case 7:
                this.info.time_limit_data.push(item)
                break
              case 8:
                this.info.coupon_data.push(item)
                break
              default:
                break
            }
          })
          this.button_list[2].disabled = this.info.goods_data.length >= 10
          this.button_list[3].disabled = this.info.service_data.length >= 10
          this.button_list[4].disabled = this.info.upkeep_card_data.length >= 3
          this.button_list[5].disabled = this.info.group_mange_data.length >= 2
          this.button_list[6].disabled = this.info.time_limit_data.length >= 2
          this.button_list[7].disabled = this.info.coupon_data.length >= 6
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取活动详情失败',
            content: `出错啦！错误码：${response.status}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动详情失败',
          content: `出错啦！错误码：${err}`,
        })
      }
    },
  },
  mounted () {
    // 如果是非连锁门店
    if (this.current_store.is_chain !== 1) {
      this.store_list = [{
        store_name: this.current_store.store_name,
        store_id: this.current_store.store_id,
      }]
      this.info.selected_stores = [this.current_store.store_id]
    }
    this.activity_id = this.$route.query.id
    this.detail = Number(this.$route.query.detail)
    this.getBrandList() // 获取品牌列表
    this.activityDetail() // 获取活动详情
  },
  watch: {
    'info.relation': function (val, old) {
      if (val) {
        val.map(item => {
          if (item.id) {
            this.active_edit = true
          } else {
            this.active_edit = false
          }
        })
      }
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@/stylus/modules/creation-modal'
.tips
  font-size 12px
  color #666
.coupon-list
  line-height 26px
  font-size 14px
  margin-top 20px
  box-sizing border-box
  padding 0 20px
  color #555
  .thead
    background #f0f1f2
.not-allow
  cursor not-allowed
.m-l-20
  margin-left 20px
.is-horizontal
  .label
    flex 0 0 88px !important
    margin-right 10px !important
.width-450
  width 450px
.width-300
  width 300px
  flex-shrink 0
.width-40
  width 40% !important
.is-red
  font-size 12px
  color red
  margin-left 20px
.label-title
  padding 20px 0
div::-webkit-scrollbar
  width 10px
  height 10px
div::-webkit-scrollbar-thumb
  background #bfbfbf
  border-radius 10px
.tips-text
  margin-left 24px
  font-size 12px
  color red
  &.no-m
    margin 0
.nav-back-btn
  position absolute
  top 36px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.editor-wrapper
  position relative
  margin-bottom 15px
  padding 25px 20px 25px 20px
  min-height 200px
  word-wrap break-word
  // border 5px solid #E8C18E
  background #fffae3
  .content-title
    width 100%
    height 36px
    display flex
    align-items center
    justify-content space-around
    margin-bottom 20px
    font-size 16px
    color #fff
    position absolute
    top -15px
    left 0
    background url('~@/assets/template/mobile-title.png') no-repeat center center / cover
    .left-icon, .right-icon
      width 40px
      height 6px
    .left-icon
      background url('https://chedian-oss1.vchangyi.com/images/assets/content-left.png')
      background-size cover
    .right-icon
      background url('https://chedian-oss1.vchangyi.com/images/assets/content-right.png')
      background-size cover
  .flower
    position absolute
    bottom 0
    right -10px
    width 25px
    height 115px
    background url('https://chedian-oss1.vchangyi.com/images/assets/content-icon.png')
    background-size cover
.enroll-wrapper
  position relative
  margin-bottom 20px
  .num
    position absolute
    bottom 3px
    left 15px
    padding-left 20px
    width 200px
    height 45px
    line-height 45px
    font-size 14px
    color #404040
    background url('~@/assets/template/mobile-car-bottom-bar.png') no-repeat center center / cover
.content-wrapper
  height 100%
.activity-wrapper
  padding 12px
  display flex
  justify-content space-between
  height calc(100% - 120px)
  &.center
    justify-content center
.line-wrapper
  width 2px
  height 100%
  background #ccc
.add-box
  .button.large
    margin 5px
    font-size 14px
  .button
    width 114px
.phone-wrapper
  flex 0 0 500px
  overflow-x hidden
  overflow-y auto
  .phone-contents
    width 375px
    background linear-gradient(360deg, rgba(251, 206, 7, 1) 0%, rgba(255, 155, 0, 1) 100%)
    border 1px solid #E4E4E4
.phone-header
  position relative
  width 373px
  background #fff
  .phone-head
    position relative
    height 42px
    line-height 42px
    text-align center
    .phone-title
      margin 0 auto
      width 160px
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
    .phone-icon
      position absolute
      top 3px
      right 8px
      width 87px
      height 32px
// .banner
// position relative
// display flex
// justify-content center
// margin-bottom 15px
// width: 100%
// height: 485px
// background: url('https://chedian-oss1.vchangyi.com/images/assets/banner.png')
// background-size: cover
// .title
// margin-top 50px
// width 272px
// height 94px
// line-height: 47px
// font-size 34px
// text-align center
// word-wrap break-word
// color #F3CC9F
.active-head
  &::after
    content ''
    box-sizing border-box
    position absolute
    top 0
    width 100%
    height 100%
    border 2px solid #FC0
.phone-item-box.active-item
  &::after
    content ''
    box-sizing border-box
    position absolute
    top 0
    width 100%
    height 100%
    border 2px solid #FC0
.phone-item-box.active-item.card-item
  &::after
    z-index 5
    height 104%
.phone-content
  padding-top 15px
  .phone-item-box
    margin 2px 0
    position relative
    .phone-item
      padding 0 15px
      min-height 112px
      // background #F6F0E8
    .phone-sort
      position absolute
      top 0
      right -60px
      padding 8px 6px
      box-shadow 0 0 2px #ccc
      .up, .down, .delete
        width 17px
        height 25px
        cursor pointer
        opacity 0.6
        &.disabled
          opacity 0.3
        &:not(.disabled):hover
          opacity 1
      .up
        background center no-repeat url('~@/assets/icons/move-up.svg')
        background-size 20px 30px
      .down
        background center no-repeat url('~@/assets/icons/move-down.svg')
        background-size 20px 30px
      .line
        margin 0 auto
        margin-top 10px
        width 16px
        height 1px
        background #ccc
      .delete
        margin-top 10px
        background center no-repeat url('~@/assets/icons/trash.svg')
        background-size 20px 30px
.phone-add
  display flex
  justify-content center
  align-items center
  width 100%
  height 150px
  background #fff
  .icon
    width 84px
    height 84px
.edit-wrapper
  flex 1
  padding-left 12px
  height 100%
  overflow-x hidden
  overflow-y scroll
  .field-group
    border-bottom 0
  .enroll
    .store_wrapper
      margin-bottom 12px
  .control-box
    width 375px
    /deep/ .ql-editor
      width 100%
      p
        word-wrap break-word
.plain-txt
  font-size 12px
  margin-right 10px
.del
  color #169bd5
  cursor pointer
.button-group.center
  text-align center
.title-store
  margin-bottom 10px
  font-size 15px
.margin-t-20
  margin-top 20px
</style>




// WEBPACK FOOTER //
// src/components/content/ContentEdit.vue